export const capitalizeWords = (string) => {
  string = string.replace(/_/g, ' ');
  return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
    letter.toUpperCase()
  );
};

export const combineWordsWithAnd = (arr) => {
  let txt = arr.join(', ');
  if (arr.length > 1) {
    txt = `${arr
      .slice(0, -1)
      .map((str) => capitalizeWords(str))
      .join(', ')} and ${arr.slice(-1).map((str) => capitalizeWords(str))}`;
  } else {
    txt = capitalizeWords(txt);
  }
  return txt;
};

// for resourece
export const formatResourceTitle = (string) => {
  let modStr = string;
  const strSplit = typeof string === 'string' ? string.split(':') : [];
  if (strSplit.length > 0) {
    modStr = strSplit.map((str) => capitalizeWords(str)).join(' : ');
  }
  return modStr;
};
